<template>
    <div class="auth">
        <div style="text-align: right">
            <span style="padding: 5px; cursor: pointer" @click="$emit('close')"
                >&times;</span
            >
        </div>
        <div>
            <div class="auth-header auth-item">
                <div>
                    <span class="item-key">服务商id:</span>
                    <span class="item-value"></span>
                    <span class="item-key">绑定邮箱:</span>
                    <span class="item-value"></span>
                </div>
                <div>
                    <span class="item-key">注册手机号:</span>
                    <span class="item-value"></span>
                    <span class="item-key">注册时间:</span>
                    <span class="item-value"></span>
                </div>
            </div>

            <div class="auth-info auth-item">
                <div>
                    <span class="item-key">企业名称:</span>
                    <span class="item-value"></span>
                    <span class="item-key">企业行业:</span>
                    <span class="item-value"></span>
                </div>
                <div>
                    <span class="item-key">企业地址:</span>
                    <span class="item-value"></span>
                    <span class="item-key">纳税人识别号:</span>
                    <span class="item-value"></span>
                </div>
            </div>
        </div>
        <div style="text-align:center">
            <a-button type="primary" style="margin-top: 20px">确认审核</a-button>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style scoped>
.auth {
    width: 900px;
    height: 300px;
    background: white;
    position: absolute;
    z-index: 9;
    border: 1px solid #eee;
    border-radius: 5px;
}
/* .auth-header span{
        display: inline-block;
        width: 200px;
        
    }
    .auth-info span{
        display: inline-block;
        width: 200px;
    } */
.auth-item {
    margin: 0 auto;
    /* background: chartreuse; */
    text-align: center;
}
.auth-item span {
    display: inline-block;
    height: 40px;
    vertical-align: middle;
    border: 1px solid #eee;
}
.item-key {
    text-align: center;
    width: 120px;
    line-height: 40px;
    /* background: violet; */
}
.item-value {
    width: 280px;
    line-height: 40px;
    /* background: yellow; */
}
/* .auth-header span:nth-child(even){
        margin-left: 100px;
    } */
</style>